export const name = "CURRENT_TIMESTAMP";
export const summary = `Returns the current date and time as a \`TIMESTAMP\` object.`;
export const reference = `
## CURRENT_TIMESTAMP

Returns the current date and time as a \`TIMESTAMP\` object.

\`\`\`
CURRENT_TIMESTAMP()
\`\`\`

### 

\`\`\`
CURRENT_TIMESTAMP
\`\`\`


### Description

Returns the current date and time as a timestamp object. The timestamp is continuous, non-ambiguous, has exactly 60 seconds per minute and doesn't repeat values over the leap second. Parentheses are optional.

This function handles leap seconds by smearing them across a window of 20 hours around the inserted leap second.

The current timestamp value is set at the start of the query statement that contains this function. All invocations of \`CURRENT_TIMESTAMP()\` within a query statement yield the same value.


### Supported Input Types

Not applicable


### Result Data Type

\`TIMESTAMP\`


### Examples



\`\`\`
SELECT CURRENT_TIMESTAMP() AS now;

/*--------------------------------*
 | now |
 +--------------------------------+
 | 2020-06-02 23:57:12.120174 UTC |
 *--------------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/timestamp_functions
`;
